import { mapState } from 'pinia';
import stores from 'store/modules';
import organization from './organization';
import NumberVendorIntegrations from 'mixins/number-vendor-integrations';

export default {
    mixins: [organization, NumberVendorIntegrations],

    computed: {
        ...mapState(stores.BillingSources, ['billingSources', 'billingSourcesSimple']),
        ...mapState(stores.EarlyUpgrade, [
            'earlyUpgradeShown',
            'earlyDowngradeShown',
            'paymentMethodsShown',
            'paymentMethodsBackup',
            'paymentMethodsRedirect',
            'onlyAnnual',
        ]),
    },

    methods: {
        showEarlyUpgrade(onlyAnnual = false) {
            if (
                this.isOnTrial &&
                this.user.isPftTrialFlow &&
                !this.hasTwilioNumberVendorIntegration
            ) {
                this.$store.dispatch('showUpgradePlanTrialModal', true);

                return;
            }

            this.$store.dispatch('showEarlyUpgrade', onlyAnnual);
        },

        hideEarlyUpgrade() {
            this.$store.dispatch('hideEarlyUpgrade');

            if (
                this.$route.name === 'settings.billing.overview.self_upgrade' ||
                this.$route.name === 'settings.billing.overview.upgrade'
            ) {
                this.$router.replace('/settings/billing/overview');
            }
        },

        showEarlyDowngrade() {
            this.$store.dispatch('showEarlyDowngrade');
        },

        hideEarlyDowngrade() {
            this.$store.dispatch('hideEarlyDowngrade');
        },

        showPaymentMethods(backup = false, redirect = true, inboxId = null, fromBroadcast = false) {
            this.$store.dispatch('showPaymentMethods', {
                backup,
                redirect,
                inboxId,
                fromBroadcast,
            });
        },

        hidePaymentMethods() {
            this.$store.dispatch('hidePaymentMethods');

            if (this.paymentMethodsRedirect && this.$route.params.modal === 'add-payment-method') {
                this.$router.replace('/settings/billing');
            }
        },
    },
};
